import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { formatJpDate } from "../../utils/dateUtils";
import { useIsDesktop } from "../../shared/hooks/useIsDesktop";
import PaginatedListLayout from "../../shared/pagination/PaginatedListLayout";
import useScrollToAnchor from "../../shared/hooks/useScrollToAnchor";
import useNoticesIndex from "./hook/useNoticesIndex";

export default function NoticesIndexPage() {
  const isDesktop = useIsDesktop();
  const scrollToAnchor = useScrollToAnchor();

  // カスタムフックから状態と操作を取得
  const { notices, pagination, loading, handlePageChange } = useNoticesIndex();

  /**
   * ページ変更時の処理
   *
   * - hook側でページ更新
   * - UI側でスクロール制御
   */
  const onPageChange = (nextPage) => {
    handlePageChange(nextPage);

    // タイトル位置までスクロール
    scrollToAnchor("notices-top", { offset: 80 });
  };

  return (
    <Container
      maxWidth="md"
      disableGutters
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ===== 固定タイトル ===== */}
      <Box
        id="notices-top"
        sx={{
          position: "sticky",
          top: isDesktop ? "63px" : "45px",
          zIndex: 20,
          backgroundColor: "#F4F7FA",
          boxShadow: 0.5,
          mx: -2,
          px: isDesktop ? 0 : 2,
          pt: isDesktop ? 1.5 : 1,
        }}
      >
        <Typography
          fontWeight="bold"
          sx={{
            fontSize: isDesktop ? "1.8rem" : "1.2rem",
            whiteSpace: "nowrap",
            mb: 2,
          }}
        >
          お知らせ一覧
        </Typography>
      </Box>

      {/* ===== 一覧 + ページング ===== */}
      <Box sx={{ flex: 1 }}>
        <PaginatedListLayout
          items={notices}
          loading={loading}
          pagination={pagination}
          onPageChange={onPageChange}
          emptyText="お知らせはありません。"
        >
          {/* お知らせリスト */}
          <Box
            sx={{
              display: "grid",
              gap: isDesktop ? 1.25 : 1,
              pb: 1,
            }}
          >
            {notices.map((notice) => (
              <Box
                key={notice.id}
                sx={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  px: isDesktop ? 2 : 1.5,
                  py: isDesktop ? 1.75 : 1.5,
                  backgroundColor: "#fff",
                }}
              >
                {/* 投稿日 */}
                <Typography
                  sx={{
                    fontSize: isDesktop ? "12px" : "11px",
                    color: "#666",
                    mb: "6px",
                  }}
                >
                  {formatJpDate(notice.published_period_start)}
                </Typography>

                {/* タイトル */}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    mb: "8px",
                    fontSize: isDesktop ? "16px" : "14px",
                  }}
                >
                  {notice.title}
                </Typography>

                {/* 本文 */}
                <Typography
                  sx={{
                    whiteSpace: "pre-wrap",
                    lineHeight: 1.6,
                    fontSize: isDesktop ? "14px" : "13px",
                  }}
                >
                  {notice.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </PaginatedListLayout>
      </Box>
    </Container>
  );
}
